import React from 'react'
import { Field } from 'formik'
import { Form } from '_zari/core'

const FlagSegundaImpresionFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagSegundaImpresion'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagSegundaImpresion'
          label='SEGUNDA IMPRESION'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagSegundaImpresionFormGroup)
